import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';

// ==============================|| ADMIN GUARD ||============================== //

interface Props {
  children: React.ReactElement | null;
}

export default function AdminGuard({ children }: Props) {
  const { isLoggedIn, isInitialized, user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = !!user?.email && user.email.endsWith('@hiyora.com');

  useEffect(() => {
    if (isInitialized && (!isLoggedIn || !isAdmin)) {
      navigate('/dashboard', { replace: true });
    }
  }, [isLoggedIn, isInitialized, isAdmin, navigate]);

  if (!isInitialized) return <Loader />;
  if (!isLoggedIn || !isAdmin) return null;

  return children;
}
